export const CONDITION_TYPES = {
  IP_ADDRESS: "SXBBZGRyZXNzQnVsa0xpc3RSaXNrUnVsZUNvbmRpdGlvbg==",
  EMAIL_ADDRESS: "RW1haWxBZGRyZXNzQnVsa0xpc3RSaXNrUnVsZUNvbmRpdGlvbg==",
  ZIP_CODE: "WmlwQ29kZUJ1bGtMaXN0Umlza1J1bGVDb25kaXRpb24=",
  PHONE_NUMBER: "UGhvbmVOdW1iZXJCdWxrTGlzdFJpc2tSdWxlQ29uZGl0aW9u",
  EMAIL_DOMAIN: "RW1haWxEb21haW5CdWxrTGlzdFJpc2tSdWxlQ29uZGl0aW9u",
  AMOUNT: "QW1vdW50Umlza1J1bGVDb25kaXRpb24=",
};
